module.exports = __webpack_public_path__ + "static/media/phoneicon.979f8a90.svg";